/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.marketing.campaigns.rpc.CampaignsRpc
 */

/**
 *  This class can be used as a response type in cases where no response is needed or
 *  where <code>void</code> might have been used in a REST-ful context.
 */

/**
 *  @deprecated use {@link PatchCampaignRequest} instead.
 */

export const getCampaignRpc = {
  serviceName: 'com.hubspot.marketing.campaigns.rpc.CampaignsRpc',
  rpcName: 'getCampaign',
  auth: 'app',
  fingerprint: 'hxGoHY-MlgvJKfBbzF7SP7svxj5gucsJ',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const createCampaignRpc = {
  serviceName: 'com.hubspot.marketing.campaigns.rpc.CampaignsRpc',
  rpcName: 'createCampaign',
  auth: 'app',
  fingerprint: 'cii6bzXyeomOZbwPefGHWrsvxj5gucsJ',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const updateCampaignRpc = {
  serviceName: 'com.hubspot.marketing.campaigns.rpc.CampaignsRpc',
  rpcName: 'updateCampaign',
  auth: 'app',
  fingerprint: '83zQ2bTobJuOZbwPefGHWrsvxj5gucsJ',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const patchCampaignRpc = {
  serviceName: 'com.hubspot.marketing.campaigns.rpc.CampaignsRpc',
  rpcName: 'patchCampaign',
  auth: 'app',
  fingerprint: '9CRQuNOGaYCOZbwPefGHWrsvxj5gucsJ',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const patchCampaignV2Rpc = {
  serviceName: 'com.hubspot.marketing.campaigns.rpc.CampaignsRpc',
  rpcName: 'patchCampaignV2',
  auth: 'app',
  fingerprint: 'AnbtFzBImmyOZbwPefGHWrsvxj5gucsJ',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getCampaignsCountRpc = {
  serviceName: 'com.hubspot.marketing.campaigns.rpc.CampaignsRpc',
  rpcName: 'getCampaignsCount',
  auth: 'app',
  fingerprint: 'AAAAAAAAAAC7hjsrvtoBbbsvxj5gucsJ',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const hasCampaignsRpc = {
  serviceName: 'com.hubspot.marketing.campaigns.rpc.CampaignsRpc',
  rpcName: 'hasCampaigns',
  auth: 'app',
  fingerprint: 'AAAAAAAAAAB4fmNhfiHs07svxj5gucsJ',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getCampaignsByGuidsRpc = {
  serviceName: 'com.hubspot.marketing.campaigns.rpc.CampaignsRpc',
  rpcName: 'getCampaignsByGuids',
  auth: 'app',
  fingerprint: 'J2_CWqMBT_QDxVsj2enDGbsvxj5gucsJ',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getCampaignByUtmRpc = {
  serviceName: 'com.hubspot.marketing.campaigns.rpc.CampaignsRpc',
  rpcName: 'getCampaignByUtm',
  auth: 'app',
  fingerprint: 'GioLgDLUcaDDUgBTg-hNWrsvxj5gucsJ',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getCampaignsColorsRpc = {
  serviceName: 'com.hubspot.marketing.campaigns.rpc.CampaignsRpc',
  rpcName: 'getCampaignsColors',
  auth: 'app',
  fingerprint: 'xJF6fPPQbX4jeEc-QtcnhLsvxj5gucsJ',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const deleteCampaignRpc = {
  serviceName: 'com.hubspot.marketing.campaigns.rpc.CampaignsRpc',
  rpcName: 'deleteCampaign',
  auth: 'app',
  fingerprint: '86Wtxyu-OD6OUe2e_r4Xmbsvxj5gucsJ',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const deleteCampaignsRpc = {
  serviceName: 'com.hubspot.marketing.campaigns.rpc.CampaignsRpc',
  rpcName: 'deleteCampaigns',
  auth: 'app',
  fingerprint: '8MhAQuG-dXCOUe2e_r4Xmbsvxj5gucsJ',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const crmPropertiesBulkUpdateRpc = {
  serviceName: 'com.hubspot.marketing.campaigns.rpc.CampaignsRpc',
  rpcName: 'crmPropertiesBulkUpdate',
  auth: 'app',
  fingerprint: 'NOThV9uzvhaOUe2e_r4Xmbsvxj5gucsJ',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getCampaignsPaginatedRpc = {
  serviceName: 'com.hubspot.marketing.campaigns.rpc.CampaignsRpc',
  rpcName: 'getCampaignsPaginated',
  auth: 'app',
  fingerprint: 'kWIjRoO6zh_ETrwWctZrtLsvxj5gucsJ',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getCstMeetingLinkRpc = {
  serviceName: 'com.hubspot.marketing.campaigns.rpc.CampaignsRpc',
  rpcName: 'getCstMeetingLink',
  auth: 'app',
  fingerprint: 'AAAAAAAAAADxNMnmSJjilLsvxj5gucsJ',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};